import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDatabase = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-database-icon lucide-database",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 12,
			cy: 5,
			rx: 9,
			ry: 3
		}),
		/* @__PURE__ */ _jsx("path", { d: "M3 5V19A9 3 0 0 0 21 19V5" }),
		/* @__PURE__ */ _jsx("path", { d: "M3 12A9 3 0 0 0 21 12" })
	]
});
export default SvgDatabase;
